import { config } from "@/config";
import {
  IIRecommendationResponse,
  IV1QuoteSessionIdGetRequest,
  v1QuoteSessionIdGet,
} from "@/contract/generated/electrify-v1";
import { useApi } from "@/hooks/useApi";
import { getSessionId, isError } from "@/utils";
import { useFormContext } from "react-hook-form";

interface IGetRecommendationResponse {
  error?: Error;
  result?: IIRecommendationResponse;
}

export const useQuote = () => {
  const { call } = useApi();
  const { getValues } = useFormContext();
  const threePhase = getValues("threePhase");
  let phaseType = "single";
  if (threePhase === "yes") {
    phaseType = "triple";
  }
  const getQuote = async (): Promise<IGetRecommendationResponse> => {
    const data: IV1QuoteSessionIdGetRequest = {
      sessionId: getSessionId(),
      phase: phaseType,
    };
    const response = await call(() =>
      v1QuoteSessionIdGet(config.apiBasePath, data)
    );

    if (isError(response)) {
      return {
        error: response as Error,
      };
    }

    const result = response as IIRecommendationResponse;

    return {
      result,
    };
  };

  return {
    getQuote,
  };
};
